import isPassiveEventListenerSupported from './isPassiveEventListenerSupported';
var defaultOptions = {
  capture: false,
  passive: false
};
/**
 * Adds an event listener for the specified event type on the specified
 * event target. The event target may be an Element in a document, the
 * Document itself, a Window, or any other object that supports events
 * (such as XMLHttpRequest).
 * @param target An object that implements the `EventTarget` interface.
 * @param type A case-sensitive string representing the event type to
 * listen for.
 * @param listener The object which receives a notification (an object
 * that implements the `Event` interface) when an event of the specified
 * type occurs. This must be an object implementing the `EventListener`
 * interface, or a JavaScript function.
 * @param [options] An options object that specifies characteristics
 * about the event listener.
 * @param [options.capture] A `Boolean` indicating that events of this
 * type will be dispatched to the registered listener before being
 * dispatched to any EventTarget beneath it in the DOM tree.
 * @param [options.passive] A `Boolean` which, if true, indicates that
 * the function specified by listener will never call preventDefault().
 */

export default function addEvent(target, type, listener) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultOptions;
  target.addEventListener(type, listener, isPassiveEventListenerSupported() ? options : options.capture);
}
//# sourceMappingURL=addEvent.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/pixel/~/@flowio/browser-helpers/dist/esm/addEvent.js
// module id = 616
// module chunks = 0 1